import React from 'react';
import { useTranslation } from 'react-i18next';

export default function MacroPreview({ planJson }) {
  const { t } = useTranslation();
  const weeks = planJson?.weeks || [];

  if (!weeks.length) return null;

  return (
    <div className="max-w-2xl mx-auto bg-white p-6 rounded-lg shadow-lg border border-gray-100 mt-6">
      <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
        <span className="text-2xl">🗺️</span>
        {t('wizard.preview.title') || 'Plan Structure Preview'}
      </h3>
      
      <div className="space-y-3">
        {weeks.map((week) => (
          <div key={week.week_number} className="flex items-center gap-3 p-3 bg-gray-50 rounded border border-gray-200">
            <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-blue-100 text-blue-700 font-bold rounded-full text-sm">
              W{week.week_number}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm text-gray-700 font-medium whitespace-normal leading-tight mb-1">
                {week.focus || t('wizard.preview.focus_tbd')}
              </div>
              <div className="text-xs text-gray-500 flex flex-wrap gap-2 items-center">
                <span className="uppercase tracking-wider font-bold text-blue-600 text-[10px] bg-blue-50 px-1 rounded">
                  {week.phase}
                </span>
                <span>•</span>
                <span>{week.week_type}</span>
                
                {/* Targets */}
                {week.targets ? (
                  <div className="flex gap-2 ml-auto text-[10px] font-mono bg-gray-100 px-2 py-0.5 rounded text-gray-600">
                    {week.targets.distance_km ? <span>{week.targets.distance_km}km</span> : null}
                    {week.targets.duration_min ? <span>{week.targets.duration_min}min</span> : null}
                    {week.targets.altitude_gain_m ? <span>{week.targets.altitude_gain_m}m+</span> : null}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-4 text-center text-xs text-gray-400 italic">
        {t('wizard.preview.generating_details') || 'Crafting daily sessions...'}
      </div>
    </div>
  );
}
